module.exports = __webpack_public_path__ + "images/emoji/sunrise_over_mountains.b620a3c950fa2c1c29c4.png";